<template>
  <div>
    <cataloging-updater></cataloging-updater>
  </div>
</template>

<script>
import CatalogingUpdater from '@/components/catalog/CatalogingUpdater.vue'
export default {
    name: 'cataloging-updater-view',
    components: {
      CatalogingUpdater
    },
    mixins: [],
    methods: {
    },
    data () {
      return {
      }
  }
}
</script>
<style lang="scss" scoped>
</style>
